import { CalendarDateFormatter, DateFormatterParams } from 'angular-calendar';
import { DatePipe } from '@angular/common';
import { Injectable } from '@angular/core';

@Injectable()
export class CustomDateFormatter extends CalendarDateFormatter {

    public monthViewColumnHeader({ date, locale }: DateFormatterParams): string {
        if (new DatePipe(locale).transform(date, 'EEEE', locale) === 'Thursday') {
            return new DatePipe(locale).transform(date, 'EEEEEE', locale);
        }
        return new DatePipe(locale).transform(date, 'EEEEE', locale);
    }

    public monthViewTitle({ date, locale }: DateFormatterParams): string {
        return new DatePipe(locale).transform(date, 'MMM y', locale);
    }
}
